import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import InsuranceBadge from "@/components/landing/InsuranceBadge";

export default function Footer({ content }) {
  const tel = `tel:${(content.phone || "").replace(/\D/g, "")}`;
  return (
    <footer className="border-t border-white/10 bg-navy/60" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-8">
          <div className="flex items-center gap-4">
            <img src="/logo.png" alt={`${content.business_name} logo`} className="h-16 w-auto rounded-xl bg-white p-1.5" />
            <div>
              <p className="font-display font-bold text-lg tracking-tight">{content.business_name}</p>
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-sky mt-1">{content.hero_overline}</p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 sm:items-center">
            <a href={tel} className="inline-flex items-center gap-2 rounded-full bg-royal px-6 py-3 font-display font-bold hover:bg-royalhover transition-colors duration-200">
              <Phone className="h-4 w-4" /> {content.phone}
            </a>
            <Link to="/admin/login" data-testid="footer-admin-link"
              className="text-sm text-slate-400 hover:text-sky transition-colors duration-200 text-center">
              Owner Login
            </Link>
          </div>
        </div>
        <div className="mt-10 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-slate-500">
            Prepare • Paint • Protect • Perfect
          </p>
          <InsuranceBadge text={content.insurance_badge} src={content.certificate_url} className="text-xs text-slate-400" />
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} {content.business_name} — {content.tagline}
          </p>
        </div>
      </div>
    </footer>
  );
}
